module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[68]555.d72154a.woff2";